import React from 'react';
import * as api from '../../api/facility'
import PageList from '../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function FacilityList(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='facility'
        title='Список доступа'
        columns={[
          { id: 'name', name: 'Имя' },
          { id: 'surname', name: 'Фамилия' },
          { id: 'patronymic', name: 'Отчество' },
          { id: 'allRu', name: 'Доступ ко всем проектам' },
        ]}
        createItem={can(SLUGS.FACILITY.ACCESS.MANAGE)}
        deleteItem={can(SLUGS.FACILITY.ACCESS.MANAGE)}
        idName='id'
        loadAPI={{
          param: {
            idFacility: props.match.params.id,
          },
          request: api.getFacilityAccess,
          transform: res => {
            return { ...res, get: res.get.map(e => ({ ...e, allRu: e.all ? 'Да' : 'Нет' })) }
          }
        }
        }
        deleteAPI={api.delFacilityAccess(props.match.params.id)}
        {...props}
      />
    </div>
  )
}